export const MainApp = () => import("@/MainApp.vue");
export const Forbidden = () =>
  import("@/components/global/layout/DepForbidden.vue");
export const Login = () =>
  import("@/features/auth/presentation/views/LoginView.vue");
export const Home = () =>
  import("@/features/dep/home/presentation/views/HomeView.vue");
export const Dashboard = () =>
  import("@/features/dep/home/presentation/views/DashboardTabView.vue");
export const DepReportGrade = () =>
  import("@/features/dep/home/presentation/views/ReportGradeTabView.vue");
export const RetrievePassword = () =>
  import(
    "@/features/auth/presentation/retrieve_password/views/RetrievePasswordView.vue"
  );

export const Followup = () =>
  import("@/components/followup/DepFollowupSection.vue");
export const DepGradeSingleSection = () =>
  import("@/components/grade-report/DepGradeSingleSection.vue");
export const Planner = () =>
  import("@/components/flutterKnotiondep/DepPlanner.vue");
export const Knotionbank = () =>
  import("@/components/flutterKnotiondep/DepKnotionBank.vue");

export const DepNotificationsSection = () =>
  import("@/components/notifications/DepNotificationsSection.vue");
export const DepNotificationsForm = () =>
  import("@/components/notifications/DepNotificationsForm.vue");
export const DepUsersForm = () => import("@/components/users/DepUsersForm.vue");
export const DepClassesSection = () =>
  import("@/components/classes/DepClassesSection.vue");
export const DepGroupsSection = () =>
  import("@/components/groups/DepGroupsSection.vue");

export const DepClassesModal = () =>
  import("@/components/global/modal/DepClassesModal.vue");

export const DepEvaluationModelsForm = () =>
  import("@/components/evaluation/evaluationModels/DepEvaluationModelsForm");
export const DepGroupsForm = () => import("@/components/groups/DepGroupsForm");

export const DepClassesForm = () =>
  import("@/components/classes/DepClassesForm");
export const DepCustomClassesForm = () =>
  import("@/components/classes/DepCustomClassesForm");

export const DepDocumentsSection = () =>
  import("@/components/documentsV2/DepDocumentSection");
export const RootMenuList = () =>
  import("@/components/documentsV2/RootMenuList");
export const SearchResult = () =>
  import("@/components/documentsV2/SearchResult");
export const CategoriesList = () =>
  import("@/components/documentsV2/CategoriesList");
export const ResourceList = () =>
  import("@/components/documentsV2/ResourceList");

export const DepStudentsForm = () =>
  import("@/components/users/DepStudentsForm");

export const DepGradeReportPage = () =>
  import("@/components/grade-report/DepGradeReportPage");

export const DepPathwayCardList = () =>
  import("@/components/followup/DepPathwayCardList");
export const DepGroupGrowthCardList = () =>
  import("@/components/followup/GroupGrowth/DepGroupCardList");

export const DepCustomSubjectsSection = () =>
  import("@/components/configuration/custom-subjects/DepCustomSubjectsSection");

export const DepNotFound = () => import("@/components/global/DepNotFound");

export const CallCenterBankStatement = () =>
  import("@/containers/callcenter/bank_statement/DepBankStatement");
export const CallCenterTransactions = () =>
  import("@/containers/callcenter/transactions/DepTransactions");
/* export const CallCenterUsers = () =>
  import("@/containers/callcenter/users/DepUsers"); */
/* export const CallCenterUsersEdit = () =>
  import("@/containers/callcenter/users/DepUsersFormContainer"); */
/* export const CallCenterStudentsForm = () =>
  import("@/containers/callcenter/users/DepStudentsFormContainer"); */
export const CallCenterNewRelative = () =>
  import("@/containers/callcenter/relatives/DepNewRelativeForm");
